// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfilePortalReceivedItem-moduleApplicantProfilePortalReceivedItem__Y692x";
var _2 = "ApplicantProfilePortalReceivedItem-modulelogo__q1gh4";
export { _1 as "ApplicantProfilePortalReceivedItem", _2 as "logo" }
